<template>
  <page-outline :title="$t('tracking.tracks_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col sm="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="2" @click="getTrack()">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>


        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="Tracking">
          <div>
            <form-accordion :title="$t('tracking.testcases')" :isTitleUpperCase="false" v-if="flagTOOLBOX && Tracking.TestCasename">
              <b-row class="form-group">
                <b-col sm="6" class="mb-5">
                  <b-table
                    class="table table-striped"
                    thead-class="d-none"
                    style="margin-bottom:0"
                    :fields="TOOLBOXTableFields"
                    :items="TrackingTestCaseTableFormattedData">
                    <template #cell(field)="data">
                      <span class="font-weight-bold">{{ getFieldTrad(data.value) }}</span>
                    </template>
                    <template #cell(value)="data">
                      <span v-if="data.item.field === 'Request1CreationDate'">{{ getDate(data.value) }}</span>
                      <span v-else>{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="flagTOOLBOX ? $t('tracking.details_request') : $t('tracking.details')" :isTitleUpperCase="false">
              <!-- {{Object.entries(Tracking).map(([key, value]) => ({'key':key,'value':value}))}} -->
              <b-row class="form-group"  v-if="flagTOOLBOX">
                <b-col sm="6" class="mb-5">
                  <b-table
                    class="table table-striped"
                    thead-class="d-none"
                    style="margin-bottom:0"
                    :fields="TOOLBOXTableFields"
                    :items="TrackingTableFormattedData">
                    <template #cell(field)="data">
                      <span class="font-weight-bold">{{ getFieldTrad(data.value) }}</span>
                    </template>
                    <template #cell(value)="data">
                      <span v-if="data.item.field === 'Request1CreationDate'">{{ getDate(data.value) }}</span>
                      <span v-else>{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="form-group" v-else>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.Provider !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.provider_ddd') : 'Provider'" :inputValue="Tracking.Provider == 1 ? 'STET' : 'EBA'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.MsgId !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.message_id_ddd') :$t('tracking.id_track')" :inputValue="Tracking.MsgId">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV'">
                  <form-read-group-label-input v-if="Tracking.IBAN !== ''"
                    :inputLabel="$t('tracking.iban')" :inputValue="Tracking.IBAN">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV'">
                  <form-read-group-label-input v-if="Tracking.IBAN !== ''"
                    :inputLabel="$t('administration.country')" :inputValue="getCountryFromIBAN(Tracking.IBAN)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BICFrom != ''">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_from_ddd') :$t('tracking.bic_from')" :inputValue="Tracking.BICFrom">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BICTo !== ''">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_to_ddd') :$t('tracking.bic_to')" :inputValue="Tracking.BICTo">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BICBillable !== '' && Tracking.BICFrom !== Tracking.BICBillable && Tracking.BICFrom !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.bic_billable')" :inputValue="Tracking.BICBillable">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.FullName !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.name')" :inputValue="Tracking.FullName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.ICQX !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.icqx')" :inputValue="Tracking.ICQX">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Reference !== '' && type === 'DDV'">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.reference')" :inputValue="Tracking.Reference">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.AdditionalInformation !== '' && type === 'DDV'">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.additional_information')" :inputValue="Tracking.AdditionalInformation">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Request1CreationDate !== ''">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_request_1_ddd') : $t('tracking.creation_date_request_1')" :inputValue="getDate(Tracking.Request1CreationDate)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Request2CreationDate !== ''">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_request_2_ddd') :$t('tracking.creation_date_request_2')" :inputValue="getDate(Tracking.Request2CreationDate)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Request1CreationDate !== '' && Tracking.CreationDateRp2 !== '' && (type === 'DDD'&& flagCACP)">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.response_time_ddd') :$t('common.response_time')" :inputValue="getDuration(Tracking)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Tracking !== '' && (type === 'DDD'&& flagCACP)">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.technical_code_ddd') :$t('tracking.technical_code')" :inputValue="Tracking.TechStatusCode !== '' ? translateTechStatusCode(Tracking.TechStatusCode) : $t('common.monitoring.success')">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <hr  class="mx-auto" />
            <form-accordion :title="$t('tracking.response')" :isTitleUpperCase="false" v-if="!flagTOOLBOX || TrackingTableRespFormattedData.length">
              <b-row v-if="flagTOOLBOX">
                <b-col sm="6" class="mb-5">
                  <b-table
                    class="table table-striped"
                    thead-class="d-none"
                    style="margin-bottom:0"
                    :fields="TOOLBOXTableFields"
                    :items="TrackingTableRespFormattedData">
                    <template #cell(field)="data">
                      <span class="font-weight-bold">{{ getFieldTrad(data.value) }}</span>
                    </template>
                    <template #cell(value)="data">
                      <span v-if="['NameScore','IdScore'].includes(data.item.field)">{{ getResultText(data.value) }}</span>
                      <span v-else-if="data.item.field === 'CreationDateRp2'">{{ getDate(data.value) }}</span>
                      <span v-else>{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="form-group" v-else>
                <b-col sm="4" class="mb-5" v-if="Tracking.CreationDateRp2 !== ''">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_response_1_ddd') :$t('tracking.creation_date_response_1')" :inputValue="getDate(Tracking.CreationDateRp2)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Response2CreationDate !== ''">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_response_2_ddd') :$t('tracking.creation_date_response_2')" :inputValue="getDate(Tracking.Response2CreationDate)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.IdScore && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.id_score')" :inputValue="getResultText(Tracking.IdScore)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.NameScore && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.name_score')" :inputValue="getResultText(Tracking.NameScore)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.RealName !== '' && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.real_name')" :inputValue="Tracking.RealName">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type == 'DDD' && (Tracking.LastName !== '' || Tracking.BirthName !== '' || Tracking.FirstName !== '' || Tracking.MarriedName !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.FirstName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.first_name')" :inputValue="Tracking.FirstName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LastName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.last_name')" :inputValue="Tracking.LastName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BirthName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.birth_name')" :inputValue="Tracking.BirthName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.MarriedName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.married_name')" :inputValue="Tracking.MarriedName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.FirstName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.first_name')" :inputValue="Tracking.FirstName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LastName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.last_name')" :inputValue="Tracking.LastName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BirthName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.birth_name')" :inputValue="Tracking.BirthName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.MarriedName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.married_name')" :inputValue="Tracking.MarriedName2">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type === 'DDD' && (Tracking.CompanyName !== '' ||  Tracking.Siren !== '' ||  Tracking.Siret !== '' ||  Tracking.TVAIntracomm !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.CompanyName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.company_name')" :inputValue="Tracking.CompanyName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TradingName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('annuaire.trading_name')" :inputValue="Tracking.TradingName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.CompanyName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.company_name')" :inputValue="Tracking.CompanyName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TradingName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('annuaire.trading_name')" :inputValue="Tracking.TradingName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID2">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type === 'DDD' && Tracking.Status === '0' &&  (Tracking.ReasonCode !== '' ||  Tracking.ReasonDescription !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.ReasonCode !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.reason_code')" :inputValue="Tracking.ReasonCode">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.ReasonDescription !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.reason_description')" :inputValue="Tracking.ReasonDescription">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('tracking.history')" :isTitleUpperCase="false">
              <b-row class="mb-3 justify-content-start ml-3 mr-3">
                <b-table
                  responsive
                  class="table table-striped"
                  :fields="fieldsTrackingHistory"
                  :items="Tracking.History"
                  v-if="Tracking.History && Tracking.History.length"
                >
                  <template #cell(status)="data">
                    <div v-if="data.item.Status !== ''">
                      {{ $t('tracking.status-' + data.item.Status) }}
                    </div>
                  </template>

                  <template #cell(statusCode)="data">
                    <div v-if="data.item.StatusCode !== ''">
                      {{ translateTechStatusCode(data.item.StatusCode) }}
                    </div>
                  </template>

                  <template #cell(processingDate)="data">
                    {{ getDate(data.item.DateTime) }}
                  </template>

                  <template #cell(buttons)="data">
                    <div
                      class="d-flex justify-content-center align-item-center"
                      v-if="['1','5','8','10','30','45','50','100','110','125','160'].includes(data.item.Status) && data.item.IdMsg"
                    >
                      <i
                        title="Open"
                        class="fas fa-eye px-1 cursor-pointer"
                        style="color: var(--actionButtonColorBlue); font-size: 15px;"
                        @click="seeJson(data.item.IdMsg, data.item.Status, 'historyTracking', 'see')"
                      ></i>

                      <i
                        title="Download"
                        class="fas fa-download px-1 cursor-pointer"
                        style="color: var(--actionButtonColorBlue); font-size: 15px;"
                        @click="seeJson(data.item.IdMsg, data.item.Status, 'historyTracking', 'download')"
                      ></i>
                    </div>
                  </template>
                </b-table>
              </b-row>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import moment from "moment";
import {DOMParser} from "xmldom";
import alpha2Country from "../../data/alpha2Country.json"
import conf from "@/config/config.dev";

export default {
  name: 'TrackingDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_delete', true) || this.$engine.rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_edit', true) || this.$engine.rights.rightIs('usercompany_edit_admin', true)
    },
    hasResponse () {
      return TrackingTableRespFormattedData.length
    },
    listTitle () {
      return this.$t('tracking.tracks_details')
    },
    TrackingTableFormattedData () {
      return this.TOOLBOXTableFieldsOrder.map((key) => ({
       field: key,
       value: this.Tracking[key]
     })).filter(elem => !!elem.value)
   },
   TrackingTestCaseTableFormattedData () {
     return this.TOOLBOXTableTestCaseFieldsOrder.map((key) => ({
      field: key,
      value: this.Tracking[key]
    })).filter(elem => !!elem.value)
   },
   TrackingTableRespFormattedData () {
     return this.TOOLBOXTableResponseFieldsOrder.map((key) => ({
      field: key,
      value: this.Tracking[key]
    })).filter(elem => !!elem.value)
   }
  },
  props: ['id', 'type'],
  data () {
    return {
      fieldsTrackingHistory: [
        { key: 'status', label: this.$t('tracking.status'), class: 'text-center w-25' },
        { key: 'statusCode', label: this.$t('tracking.status_code'), class: 'text-center w-25' },
        { key: 'processingDate', label: this.$t('tracking.processing_date'), class: 'text-center w-25' },
        { key: 'buttons', label: '', class: 'text-center align-middle w-25' }
      ],
      flagCACP: conf.visual === 'CACP',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      activateSpinner: false,
      countries: alpha2Country.countries.reverse(),
      TOOLBOXTableFieldsOrder: ['Reference', 'IBAN', 'FullName', 'LEI', 'BIC', 'Identifier', 'Request1CreationDate'],
      TOOLBOXTableTestCaseFieldsOrder: ['TestCasename', 'TestCaseStatus'],
      TOOLBOXTableResponseFieldsOrder: ['CreationDateRp2', 'NameScore', 'IdScore'],
      TOOLBOXTableFields: [
        { key: 'field', label: '', class: 'text-left', sortable: false },
        { key: 'value', label: '', class: 'text-left', sortable: false },
      ],
      returnUrl: '',
      resultMatchingOptions: [
        { id: "NOAP", text: "Not Applicable" },
        { id: "MTCH", text: "Match" },
        { id: "NMTC", text: "No Match" },
        { id: "CMTC", text: "Close Match" },
        { id: "NULL", text: this.$t('tracking.no_result') }
      ],
      Tracking: {}
    }
  },
  created () {
    this.idTrackingBulk = this.$route.query.idTrackingBulk
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getTrack()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    getFieldTrad (field) {
      switch (field) {
        case 'IBAN':
          return this.$t('tracking.iban')
        case 'Identifier':
          return this.$t('tracking.identifier')
        case 'Reference':
          return this.$t('tracking.reference')
        case 'Request1CreationDate':
          return this.$t('common.dt')
        case 'TestCasename':
          return this.$t('tracking.testcase_name')
        case 'TestCaseStatus':
          return this.$t('tracking.testcase_status')
        case 'NameScore':
          return this.$t('tracking.name_score')
        case 'IdScore':
          return this.$t('tracking.name_score')
        case 'CreationDateRp2':
          return this.$t('common.dt')
        case 'LEI':
          return this.$t('tracking.select.identifiers.LEIC.label')
        case 'BIC':
          return this.$t('tracking.bic')
        default:
          return field
      }
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, status, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking.getJSON({service, id, status, Type:this.type})
      .then((resp) => {
        if (resp.data) {
          dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
          dataDetails.type = service
          if (action === 'see') {
            that.$bus.emit('popup-json-details', dataDetails)
          } else {
            //download file
            let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.txt'
              const blob = new Blob([data], { type: 'text/plain' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.txt_downloaded'))
          }
        }
      })
      .catch((error) => {
        errorMessageAlert(error, that)
      })
    },
    getDateDay (date){
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
    },
    getDate (date){
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
    },
    getResultText (id) {
      const option = this.resultMatchingOptions.find(opt => opt.id === id)
      return option ? option.text : '-'
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }

    },
    defineReturnURL() {
      let that = this
      let type = parseInt(this.type, 10)
      if (!isNaN(type) && this.type == type){
        this.returnUrl =  '/tracking/BULKDETAILS/'+ this.type
      }else{
        if (this.idTrackingBulk !== undefined) {
          this.returnUrl = '/trackingbulk/' + this.idTrackingBulk
        }
        else {
          this.returnUrl =  '/tracking/'+ this.type+'/NULL'
        }
      }
    },
    getCountryFromIBAN(iban) {
      if (!iban || typeof iban !== 'string' || iban.length < 2) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      const countryCode = iban.substring(0, 2).toUpperCase()

      if (!this.countries.includes(countryCode)) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      return this.$t(`countriesAlpha2Code.${countryCode}`) || this.$t('countriesAlpha2Code.UNKNOWN')
    },
    getTrack () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        Type: this.type,
        IdTrack: this.id
      }
      that.$engine.tracking.getTracks(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        if (resp.data && resp.data.tracks && resp.data.tracks.length) {
          that.Tracking = resp.data.tracks[0]
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getDuration (item) {
      if (item.Request1CreationDate !== '' && item.Request2CreationDate !== '' && item.Response2CreationDate !== '' && item.CreationDateRp2 !== '') {
        const start = moment(item.Request1CreationDate)
        const end = moment(item.CreationDateRp2)

        return end.diff(start, 'milliseconds') + ' ms'
      }
      else {
        return '-'
      }
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    }
  }
}
</script>
